import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleLogin from './GoogleLogin';

function googleComponent() {
    return (
        <GoogleOAuthProvider clientId="409239270737-b3vrirrv1ous3jvl42sp0cai72d815g1.apps.googleusercontent.com">
            <GoogleLogin />
        </GoogleOAuthProvider>
    );
}

export default googleComponent;